import {
  toggleCategory,
} from '../../../store/slices';
import {
  type DocumentCategory as DocumentCategoryType,
} from '../../../types';
import { DocumentCategoryName } from './DocumentCategoryName';
import { DocumentGroup } from './DocumentGroup';
import {
  type FC,
} from 'react';
import {
  useDispatch,
} from 'react-redux';

export const DocumentCategory: FC<DocumentCategoryType> = ({
  categoryId: topLevelCategoryId,
  categoryName,
  documentTypeGroups,
  isNewDocumentsCategory,
  isOpen,
}) => {
  const dispatch = useDispatch();
  const totalNumberOfNewDocuments = documentTypeGroups.reduce(
    (total, group) => total + (group.numberOfNewDocuments || 0),
    0,
  );
  const toggleCategoryOnClick = () => {
    dispatch(toggleCategory({
      isNewDocumentsCategory,
      isOpen: !isOpen,
      topLevelCategoryId,
    }));
  };

  const toggleCategoryOnKeyDown = (
    event?: React.KeyboardEvent<HTMLDivElement>,
  ) => {
    if (!event || event.key !== 'Tab') {
      return;
    }

    dispatch(toggleCategory({
      isNewDocumentsCategory,
      isOpen: !isOpen,
      topLevelCategoryId,
    }));
  };

  return (
    <div
      aria-expanded={isOpen}
      className='flex h-fit w-full max-w-[90rem] flex-col gap-[0.75rem] rounded-full border border-black-200 p-[0.75rem] ms:flex-row ms:rounded-none ms:border-b ms:border-x-transparent ms:border-t-transparent ms:px-0'
      data-test={`document-category-${categoryName}`}
    >
      {
        isOpen ?
          <>
            <DocumentCategoryName
              categoryName={categoryName}
              isNewDocumentsCategory={isNewDocumentsCategory}
              isOpen={isOpen}
              toggleCategoryOnClick={toggleCategoryOnClick}
              toggleCategoryOnKeyDown={toggleCategoryOnKeyDown}
              totalNumberOfNewDocuments={totalNumberOfNewDocuments}
            />
            <div className='flex w-full flex-col gap-[0.375rem] overflow-visible'>
              {
                documentTypeGroups.map((group) => <DocumentGroup
                  isNewDocumentsCategory={isNewDocumentsCategory}
                  // eslint-disable-next-line max-len
                  key={`${topLevelCategoryId}${group.categoryId}${group.documentGroupId}${isNewDocumentsCategory}`}
                  topLevelCategoryId={topLevelCategoryId}
                  {...group}
                />)
              }
            </div>
          </> :
          <div className='flex size-full min-h-8 flex-col justify-center ms:min-h-16'>
            <DocumentCategoryName
              categoryName={categoryName}
              isNewDocumentsCategory={isNewDocumentsCategory}
              isOpen={isOpen}
              toggleCategoryOnClick={toggleCategoryOnClick}
              toggleCategoryOnKeyDown={toggleCategoryOnKeyDown}
              totalNumberOfNewDocuments={totalNumberOfNewDocuments}
            />
          </div>
      }
    </div>
  );
};
